jQuery(window).on('load', function () {

    function init() {
        $('.market-survey-select').off('click').click(function (e) {
            //Stop drawer to open and checkbox to check
            e.stopPropagation();
            e.preventDefault();

            //Toggle Checkbox
            var checkBoxes = $(this).find('input');

            if (checkBoxes.prop("checked") === false) {
                checkBoxes.prop("checked", true);
                storage.addTo('properties', $(checkBoxes).attr('data-id'));
            } else if (checkBoxes.prop("checked") === true) {
                checkBoxes.prop("checked", false);
                storage.removeFrom('properties', $(checkBoxes).attr('data-id'));
            }

            showHideGenerateButton();
        });

        // Remove on click
        $('#market-survey-table').on('click', '.remove-column', function () {

            var id = $(this).attr('data-id');

            // Remove the entry from storage and the table
            storage.removeFrom('properties', id);
            $('.survey-row[data-id=' + id + ']').addClass('hide');

            // Uncheck the MLS checkboxes
            $('input[type=checkbox][data-id=' + id + ']').prop('checked', false);

            showHideGenerateButton();
        });

        $("#select-market-survey:not('.survey-initialized')").addClass('survey-initialized');

        showHideGenerateButton();
    }

    function beforeInit() {
        $('#generate-survey-link').click(function () {
            loadSurvey();
            openSurvey();
        });

        $('.survey-drawer-button-close').click(function () {
            closeSurvey();
        });

        reset();
    }

    function reset() {
        $('.survey-row').remove();
        storage.removeAll();
        sessionStorage.clear();
    }

    function openIFrame() {
        var checkeds = storage.get('properties');

        if (checkeds) {
            var ids = [];

            for (var i in checkeds) {
                if (checkeds.hasOwnProperty(i)) {
                    ids.push("ids[]=" + checkeds[i]);
                }
            }

            return $('body').attr('data-base-url') + 'survey?' + ids.join('&');
        }
    }

    function showHideGenerateButton() {
        var properties = storage.get('properties');
        var checkeds = properties ? properties.length : 0;

        if (checkeds > 1) {
            $('#generate-survey-market').fadeIn(500);
        } else {
            $('#generate-survey-market').fadeOut(500);

            // If the slideout is open, close it
            closeSurvey();
        }

        if (checkeds === 2) {
            if (!sessionStorage.getItem('showedMessage')) {
                $('.tap-target').tapTarget('open');

                sessionStorage.setItem('showedMessage', true);

                setTimeout(function () {
                    $('.tap-target').tapTarget('close');
                }, 3000);

            }
        }
    }

    function openSurvey() {
        $('.drawer-survey').addClass('open');
        $('body').addClass('hide-overflow');
        // $('.print-market-survey').attr('href', openIFrame());
    }


    function closeSurvey() {
        $('.drawer-survey').removeClass('open');
        setTimeout(function () {
            $('body').removeClass('hide-overflow');
        }, 1000);
    }

    function getPreparedForName() {

        // Create the modal
        $('body').append('' +
            '<div id="modal-prepared" class="modal">' +
            '<div class="modal-content"><div>' +
            '<h3>Who are you preparing this report for?</h3>' +
            '<div class="input-field">' +
            '<input id="modal-input-recipient" type="text" />' +
            '<label>Recipient Name</label>' +
            '</div>' +
            '<button id="modal-submit-recipient" class="waves-effect waves-light btn">Continue</button>' +
            '</div></div></div></div>');
        $('#modal-prepared').modal();

        $('#survey-detail').on('click', '.print-market-survey', function (e) {

            e.preventDefault();

            // Open the modal
            $('#modal-prepared').modal('open');
        });

        // On close, add the name information to the survey URL
        $('body').on('click', '#modal-submit-recipient', function () {

            var recipient = $('#modal-input-recipient').val();

            // Open the URL in the new window
            var target = openIFrame() + "&recip=" + encodeURIComponent(recipient);

            window.open(target);

            $('#modal-prepared').modal('close');
        });
    }

    function addFixedFields(data, marketSurvey) {
        var listing = null;
        var j = null;

        var tr = $('<tr data-ref="property_image_url"/>');
        tr.append("<th/>");
        for (j in data.listings) {
            if (data.listings.hasOwnProperty(j)) {
                listing = data.listings[j];

                tr.append(getImage(listing.property_image_url, listing.id));
            }
        }
        marketSurvey.find('thead').append(tr);

        //Address
        tr = $('<tr data-ref="street_address_details" class="header"/>');
        tr.append("<th/>").html('<th>Property Name</th>');
        for (j in data.listings) {
            if (data.listings.hasOwnProperty(j)) {
                listing = data.listings[j];
                var address = listing.street_address_details ? listing.street_address_details.replace(/<\/?[^>]+(>|$)/g, "") : null;
                var link = listing.link ? listing.link : null;
                if (address) {
                    tr.append(getCell(address, listing.id, link));
                }
            }
        }
        marketSurvey.find('thead').append(tr);
    }

    function addRelativeFields(data, marketSurvey) {
        var headers = data.headers;
        var tr = null;

        for (var i in headers) {
            if (headers.hasOwnProperty(i)) {
                tr = $('<tr data-ref="' + headers[i] + '"/>');
                tr.append("<th/>").html('<th>' + headers[i] + '</th>');

                for (var j in data.listings) {
                    if (data.listings.hasOwnProperty(j)) {
                        var listing = data.listings[j];
                        tr.append(getCell(listing[headers[i]], listing.id));
                    }
                }

                marketSurvey.find('thead').append(tr);
            }
        }
    }

    function loadSurvey() {
        $('.survey-row').remove();

        var checkeds = storage.get('properties');

        if (checkeds) {
            var ids = [];

            for (var i in checkeds) {
                if (checkeds.hasOwnProperty(i)) {
                    if (checkeds[i] !== undefined) {
                        ids.push(checkeds[i]);
                    }
                }
            }

            $.get($('body').attr('data-base-url') + "mls/get_market_survey", {ids: ids}, function (responseTxt) {
                var marketSurvey = $('#market-survey-table');
                marketSurvey.find('thead').empty();

                var data = JSON.parse(responseTxt);

                addFixedFields(data, marketSurvey);
                addRelativeFields(data, marketSurvey);
            });
        }
    }

    function loadProperty(property) {
        $('#market-survey-table').find("[data-ref='property_image_url']").append(getImage(property.listing_image_url, property.id));
        $('#market-survey-table').find("[data-ref='street_address_details']").append(getCell(property.street_address_details, property.id));
        $('#market-survey-table').find("[data-ref='street_address']").append(getCell(property.street_address, property.id));
        $('#market-survey-table').find("[data-ref='zonings']").append(getCell(property.zonings, property.id));
        $('#market-survey-table').find("[data-ref='building_size']").append(getCell(property.building_size, property.id));
        $('#market-survey-table').find("[data-ref='building_size_suites_parcels']").append(getCell(property.building_size_suites_parcels, property.id));
        $('#market-survey-table').find("[data-ref='suites_total']").append(getCell(property.suites_total, property.id));
        $('#market-survey-table').find("[data-ref='parking']").append(getCell(property.parking, property.id));
        $('#market-survey-table').find("[data-ref='building_price_suites_parcels']").append(getCell(property.building_price_suites_parcels, property.id));
        $('#market-survey-table').find("[data-ref='janitorial']").append(getCell(property.janitorial, property.id));
        $('#market-survey-table').find("[data-ref='tenant_allowance']").append(getCell(property.tenant_allowance, property.id));
        $('#market-survey-table').find("[data-ref='notes']").append(getCell(property.notes, property.id));
    }

    function getCell(field, id, link) {

        if (link) {
            field = '<a href="' + link + '" target="_blank">' + field + '<i class="material-icons">insert_link</i></a>';
        }

        if (id) {
            id = "data-id='" + id + "'";
        }

        return $("<td class='survey-row' " + id + " />").html((field && field.length > 0 ? field : '-'))[0].outerHTML;
    }

    function getImage(image_url, id) {
        if (!image_url) {
            image_url = $('body').attr('data-base-url') + "assets/img/default-placeholder.png";
        }
        var row = $("<td class='survey-row' data-id='" + id + "'><div class='remove-column' data-id='" + id + "'></div></td>");
        var imageCell = $('<img/>').attr('src', Utils.imageUrl(image_url)).attr('onerror', "this.src='" + $('body').attr('data-base-url') + "assets/img/default-placeholder.png'");
        var imagePlaceholderCell = $('<img/>').attr('src', $('body').attr('data-base-url') + "assets/img/default-placeholder.png");
        var image = image_url ? imageCell : imagePlaceholderCell;

        return row.append(image);
    }

    if (window.SurveyMarket === undefined) {
        window.SurveyMarket = {};
    }

    if ($('.mls').length > 0) {
        beforeInit();
        getPreparedForName();
    }
    window.SurveyMarket = {
        init: init
    };
});

function finishiLoadingSurveyFrame() {
    $.LoadingOverlay("hide");
}


